var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.6340675%",
    y1: "61.1983224%",
    x2: "159.526257%",
    y2: "25.1225176%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f69923",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f79a23",
    offset: "31.23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: "83.83%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-49.00265%",
    y1: "394.970831%",
    x2: "59.2482194%",
    y2: "13.7454494%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e2064",
    offset: "32.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c92037",
    offset: "63.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2335",
    offset: "75.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.6186724%",
    y1: "178.962598%",
    x2: "125.360894%",
    y2: "-118.809754%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282662",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662e8d",
    offset: "9.54839%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f2064",
    offset: "78.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2032",
    offset: "94.87%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.5496397%",
    y1: "170.497289%",
    x2: "68.9150286%",
    y2: "-44.4029666%",
    id: "D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e2064",
    offset: "32.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c92037",
    offset: "63.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2335",
    offset: "75.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.7552564%",
    y1: "77.304969%",
    x2: "60.506571%",
    y2: "-41.4214613%",
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282662",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662e8d",
    offset: "9.54839%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9f2064",
    offset: "78.82%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2032",
    offset: "94.87%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.416217114%",
    y1: "187.679939%",
    x2: "85.627807%",
    y2: "-51.0282024%",
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e2064",
    offset: "32.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c92037",
    offset: "63.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2335",
    offset: "75.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-129.864381%",
    y1: "415.890921%",
    x2: "66.5775346%",
    y2: "21.0275949%",
    id: "G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e2064",
    offset: "32.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c92037",
    offset: "63.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2335",
    offset: "75.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4514.6935%",
    y1: "6209.93291%",
    x2: "2842.37853%",
    y2: "-3713.12252%",
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e2064",
    offset: "32.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c92037",
    offset: "63.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2335",
    offset: "75.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-15277.8157%",
    y1: "32747.0113%",
    x2: "7529.10757%",
    y2: "-15859.0689%",
    id: "I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9e2064",
    offset: "32.33%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c92037",
    offset: "63.02%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cd2335",
    offset: "75.14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "5.22601705e-14%",
    y1: "50.0000067%",
    x2: "100%",
    y2: "50.0000067%",
    id: "J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f69923",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f79a23",
    offset: "31.23%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e97826",
    offset: "83.83%"
  })), /*#__PURE__*/React.createElement("path", {
    id: "K",
    d: "M35.995 45.92c-.08.022-.158.033-.244.055.08-.022.158-.044.244-.055z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    d: "M36.626 43.9c.033 0 .066-.01.1-.01-.033 0-.066.01-.1.01z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.28 26.768c-.662.394-1.765 1.496-3.072 3.093l1.205 2.275c.843-1.212 1.7-2.298 2.576-3.227l.102-.1c-.032.04-.07.07-.102.1-.284.307-1.134 1.3-2.42 3.274 1.237-.063 3.135-.315 4.687-.582.465-2.582-.45-3.763-.45-3.763s-1.166-1.88-2.53-1.07z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#be202e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.224 45.864l-.473.1a1.95 1.95 0 0 0 .244-.055 1.47 1.47 0 0 0 .228-.055z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.224 45.864l-.473.1a1.95 1.95 0 0 0 .244-.055 1.47 1.47 0 0 0 .228-.055z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.633 43.9c.024 0 .047-.01.07-.01l.3-.077-.37.088z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.633 43.9c.024 0 .047-.01.07-.01l.3-.077-.37.088z",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.853 38.008L35.964 36l1.182-1.968.07-.1 1.2-1.795L37.2 29.86l-.276.338-1.08 1.393-1.284 1.77-1.22 1.803-1.04 1.637-.04.063 1.568 3.093 1.024-1.952z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.708 55.46l-.622 1.747c0 .008-.008.016-.008.024l-.63 1.834c.465.213.835.764 1.182 1.393-.04-.653-.307-1.267-.82-1.74 2.277.102 4.246-.472 5.255-2.14l.252-.472c-.465.582-1.032.834-2.11.77 1.583-.708 2.38-1.393 3.08-2.52l.496-.882c-1.387 1.425-2.994 1.826-4.687 1.52l-1.268.142-.118.323z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3 52.617l.843-2.15.85-2.086.9-2.102.945-2.133.97-2.094.362-.748.63-1.275c.008-.024.024-.047.032-.07l-1.552-3.086c-.024.04-.047.087-.08.126l-1.087 1.826-1.064 1.92-.86 1.66-.165.338-.93 2.04-.835 2.117-.44 1.275-.315 1.047-.6 2.456 1.576 3.11.638-1.692.19-.48z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.872 51.79c-.197.992-.34 1.984-.4 2.975 0 .03-.008.07-.008.102-.488-.787-1.812-1.56-1.804-1.55.945 1.37 1.662 2.723 1.765 4.054-.504.102-1.197-.047-1.993-.338.835.764 1.457.976 1.702 1.03-.764.047-1.56.575-2.363 1.18 1.174-.48 2.127-.67 2.805-.512-1.08 3.046-2.16 6.415-3.238 9.99.33-.094.528-.323.638-.622.19-.645 1.473-4.896 3.474-10.477l.173-.48c.016-.047.032-.087.047-.134l.662-1.795.158-.417-1.576-3.117a.58.58 0 0 0-.032.11z",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.08 40.228l-.134.275-.4.858-.457.968-.236.504-.717 1.582-.906 2.086-.9 2.133-.867 2.165-.788 2.047c-.016.03-.024.07-.04.102l-.796 2.14c-.008.016-.016.03-.016.047l1.268-.142c-.024-.008-.047-.008-.08-.016 1.52-.19 3.537-1.322 4.837-2.723.6-.645 1.142-1.4 1.646-2.29a19.35 19.35 0 0 0 1.064-2.212l.843-2.314c-.347.18-.748.315-1.2.41l-.236.047-.244.04c1.418-.543 2.308-1.6 2.954-2.88-.37.252-.977.582-1.702.748-.095.024-.197.04-.3.055-.024 0-.047.008-.08.008a5.72 5.72 0 0 0 1.268-.708 2.45 2.45 0 0 0 .221-.181c.1-.094.213-.197.315-.3l.19-.205c.142-.165.276-.346.394-.543l.1-.18.134-.268.48-1.063.165-.433c.016-.055.04-.102.055-.157l.126-.4.095-.417c-.047.04-.102.08-.165.1-.425.252-1.158.488-1.75.598l1.166-.126-1.166.126c-.008 0-.016 0-.024.008l-.18.03c.008-.008.024-.008.032-.016l-3.986.433c.008.03 0 .047-.008.055z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.57 32.183l-1.158 1.858c-.024.04-.047.07-.063.1l-1.142 2-1.087 2.03-1.016 2.007 3.986-.433c1.158-.535 1.678-1.015 2.182-1.716l.402-.606c.4-.638.81-1.338 1.166-2.04l.882-1.944.355-1.055.173-.787-4.68.575z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#be202e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#be202e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    opacity: 0.35
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#L",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.46 39.735v.738h-.162v-.738h-.204v-.177h.564v.177zm.953.162l-.192.5h-.096l-.192-.5v.577h-.156v-.915h.216l.186.5.186-.5h.216v.915h-.156v-.577z",
    fill: "#b0afb0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.003 67.598c-.666 0-1.25-.036-1.75-.107-.502-.06-.927-.138-1.275-.23V63.3l1.198.215c.4.06.86.092 1.352.092.47 0 .906-.05 1.306-.153a2.54 2.54 0 0 0 1.06-.537c.307-.246.543-.578.707-.998.174-.42.26-.946.26-1.58V38.562h4.76v21.624c0 1.29-.19 2.4-.568 3.33-.37.93-.89 1.698-1.567 2.302-.666.614-1.464 1.064-2.396 1.35s-1.96.43-3.087.43",
    stroke: "#d22128",
    strokeWidth: 0.55,
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.205 61l-4.93-17.603h-.138l.154 2.732.046 1.166.046 1.182.03 1.12.015.967V61h-4.255V38.562h6.482L66.5 55.72h.092l5.16-17.158h6.482V61h-4.44V49.474l.03-1.074.03-1.15.046-1.136.108-2.686h-.123L68.582 61h-4.377M87.76 46.85a2.74 2.74 0 0 0-2.074.875c-.543.583-.855 1.5-.937 2.747h5.975a5.76 5.76 0 0 0-.2-1.443c-.123-.44-.307-.818-.553-1.136-.246-.327-.553-.583-.922-.767s-.8-.276-1.3-.276m.6 14.457c-1.23 0-2.36-.18-3.394-.537s-1.925-.895-2.673-1.6c-.748-.726-1.33-1.637-1.75-2.732-.4-1.105-.614-2.4-.614-3.883 0-1.504.2-2.82.568-3.944s.906-2.062 1.582-2.808c.686-.757 1.505-1.325 2.458-1.703.963-.38 2.027-.568 3.195-.568 1.137 0 2.16.174 3.072.522.922.338 1.7.84 2.335 1.504.645.665 1.137 1.484 1.475 2.455.348.962.522 2.067.522 3.315v2.27H84.658c.02.655.123 1.248.307 1.78.195.522.46.967.8 1.335.348.358.763.634 1.244.83.5.194 1.05.292 1.674.292.522 0 1.014-.026 1.475-.077.47-.06.927-.148 1.367-.26a12.07 12.07 0 0 0 1.306-.414l1.32-.6v3.622a9.41 9.41 0 0 1-1.244.552 10.96 10.96 0 0 1-1.306.368c-.46.102-.957.174-1.5.215l-1.75.077m16.183-3.73a5.37 5.37 0 0 0 1.306-.153 12.84 12.84 0 0 0 1.275-.384v3.484c-.44.225-.988.4-1.643.552-.645.153-1.352.23-2.12.23a8 8 0 0 1-2.089-.261 3.98 3.98 0 0 1-1.674-.905c-.47-.44-.845-1.023-1.12-1.75-.266-.737-.4-1.657-.4-2.762v-8.272h-2.242v-1.98l2.58-1.565 1.352-3.622h2.995v3.653h4.178v3.514h-4.178v8.272c0 .665.164 1.156.492 1.473s.758.476 1.3.476m11.416-10.727a2.74 2.74 0 0 0-2.074.875c-.543.583-.855 1.5-.937 2.747h5.975a5.76 5.76 0 0 0-.2-1.443c-.123-.44-.307-.818-.553-1.136-.246-.327-.553-.583-.922-.767s-.8-.276-1.3-.276m.6 14.457c-1.23 0-2.36-.18-3.394-.537s-1.925-.895-2.673-1.6c-.748-.726-1.33-1.637-1.75-2.732-.4-1.105-.614-2.4-.614-3.883 0-1.504.2-2.82.568-3.944s.906-2.062 1.582-2.808c.686-.757 1.505-1.325 2.458-1.703.963-.38 2.027-.568 3.195-.568 1.137 0 2.16.174 3.072.522.922.338 1.7.84 2.335 1.504.645.665 1.137 1.484 1.475 2.455.348.962.522 2.067.522 3.315v2.27H112.86c.02.655.123 1.248.307 1.78.195.522.46.967.8 1.335.348.358.763.634 1.244.83.5.194 1.05.292 1.674.292.522 0 1.014-.026 1.475-.077.47-.06.927-.148 1.367-.26a12.07 12.07 0 0 0 1.306-.414l1.32-.6v3.622a9.41 9.41 0 0 1-1.244.552 10.96 10.96 0 0 1-1.306.368c-.46.102-.957.174-1.5.215l-1.75.077m17-17.788l.4.015a2.84 2.84 0 0 1 .43.031l.384.046a1.27 1.27 0 0 1 .276.046v4.4a3.53 3.53 0 0 0-.338-.061l-.46-.046a3.49 3.49 0 0 0-.461-.031l-.384-.015a5.81 5.81 0 0 0-1.674.23 3.26 3.26 0 0 0-1.306.752c-.358.338-.64.788-.845 1.35-.195.552-.292 1.233-.292 2.04V61h-4.685V43.84h3.548l.7 2.578h.23c.246-.44.512-.84.8-1.197s.604-.66.952-.905c.358-.256.758-.45 1.198-.583.45-.143.963-.215 1.536-.215m6.198-.04h-1.04v-4.054h-1.237v-.87h3.512v.87h-1.233v4.054m3.972 0l-1.082-3.862h-.03l.034.6.02.516.007.246.003.212v2.3h-.934v-4.923h1.422l1.065 3.765h.02l1.132-3.765h1.422V43.5h-.974v-2.53l.007-.236.007-.253.01-.25.024-.6h-.027l-1.166 3.856h-.96",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.796 35.112l3.363-8.03h.648l3.363 8.03h-.846l-1.044-2.508h-3.616l-1.03 2.508h-.84zm3.7-7.103l-1.65 3.967h3.26l-1.6-3.967zm4.544 7.103v-8.03h3.33c1.378 0 2.374 1.275 2.374 2.522 0 1.3-.928 2.542-2.306 2.542h-2.613v2.965h-.785zm.785-3.667h2.572c.948 0 1.562-.872 1.562-1.84 0-1-.744-1.82-1.63-1.82h-2.504v3.66zm4.482 3.667l3.363-8.03h.648l3.363 8.03h-.86l-1.044-2.508h-3.6l-1.03 2.508h-.832zm3.7-7.103l-1.65 3.967h3.26l-1.6-3.967zm7.477-.974c1.426 0 2.47.723 2.968 1.752l-.634.382c-.512-1.063-1.508-1.425-2.374-1.425-1.924 0-2.974 1.718-2.974 3.333 0 1.772 1.303 3.38 3 3.38.907 0 1.972-.45 2.476-1.493l.655.34c-.518 1.2-1.944 1.868-3.18 1.868-2.204 0-3.76-2.106-3.76-4.138 0-1.93 1.392-4 3.813-4zm10.568.047v8.03h-.8v-3.756H77.48v3.756h-.78v-8.03h.778v3.572h4.762v-3.572h.8zm7.2 7.318v.702h-5.396v-8.03h5.294v.702h-4.516v2.897h3.936v.668h-3.936v3.06h4.618z",
    fill: "#d22128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJMeter);
export default __webpack_public_path__ + "static/media/JMeter.ef75608676904532401391c838a94f2e.svg";
export { ForwardRef as ReactComponent };